import { Link } from "react-router-dom";
import { TRAButton } from "../../../design";
import { LoadingState, ErrorState } from "../../../design/shell";
import { usePlayerHomeData } from "../hooks/usePlayerHomeData";
import {
  HomeTodayTopSections,
  RecentFormSection,
  AchievementCarousel,
  OrganizationSummary,
  MyCompetitionsSection,
  CompetitionSpotlightCard,
  HomeNextMatchSection,
  HomeDrawBannerList,
} from "./PlayerHomeSections";
import RefereeInviteBanner from "./RefereeInviteBanner";
import styles from "../styles/playerExperience.module.css";

/**
 * Player Home — greeting + CTAs paint immediately; sections fill as data arrives.
 */
export default function PlayerHomePage() {
  const {
    dash,
    ranking,
    suggested,
    loading,
    error,
    reload,
    greet,
    headline,
    resumeRoom,
    canHostTournament,
  } = usePlayerHomeData();

  if (!loading && !dash) {
    return (
      <ErrorState
        title={error || "Could not load home"}
        description="Check your connection and try again."
        action={
          <TRAButton type="button" variant="primary" onClick={() => void reload()}>
            Retry
          </TRAButton>
        }
      />
    );
  }

  const achievements = [
    ...(ranking?.achievements || []),
    ...(dash?.achievements || []),
  ].slice(0, 8);
  const drawBanners = dash?.registrations?.drawBanners || [];

  return (
    <div className={styles.page} data-testid="player-home">
      <div className={styles.homeTopCluster}>
        <header className={styles.homeHero}>
          <p className={styles.greeting}>{greet}</p>
          <h1 className={styles.greetingHeadline} data-tra-text-bold="home-hero">
            {headline}
          </h1>
        </header>

        <RefereeInviteBanner />
        <HomeDrawBannerList banners={drawBanners} />

        <HomeTodayTopSections
          resumeRoom={resumeRoom}
          stats={dash?.stats}
          recentMatches={dash?.recentMatches || []}
          canHostTournament={canHostTournament}
        />
      </div>

      {drawBanners.length ? null : (
        <HomeNextMatchSection fixture={dash?.registrations?.nextFixture} />
      )}

      {loading && !dash ? (
        <LoadingState label="Loading your season" />
      ) : (
        <>
          <RecentFormSection matches={dash?.recentMatches || []} />

          <AchievementCarousel achievements={achievements} />

          <OrganizationSummary badges={dash?.organizationBadges || []} />

          <MyCompetitionsSection
            current={dash?.registrations?.current || []}
            upcoming={dash?.registrations?.upcoming || []}
          />

          {drawBanners.length || dash?.registrations?.nextFixture ? null : (
            <CompetitionSpotlightCard competition={suggested[0] || null} />
          )}

          {!suggested[0] ? (
            <p className={styles.homeEmptyHint}>
              Looking for a tournament?{" "}
              <Link to="/discover" className={styles.linkAction}>
                Explore Discover
              </Link>
            </p>
          ) : null}
        </>
      )}
    </div>
  );
}
